import { render, staticRenderFns } from "./crudOrdersApiRules.vue?vue&type=template&id=7a28f759"
import script from "./crudOrdersApiRules.vue?vue&type=script&lang=js"
export * from "./crudOrdersApiRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports